var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';
import { Translate } from "../../../I18N";









const Text = ({
  checked,
  disabled,
  hovering




}) => {
  switch (true) {
    case checked && hovering && !disabled:
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "Disable");

    case checked && disabled:
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "Activated");

    case checked && !hovering:
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "Activated");

    default:
      return /*#__PURE__*/_jsx(Translate, {}, void 0, "Activate");
  }
};

const EnableButtonCheckbox = /*#__PURE__*/React.forwardRef(
  (
  { name, onChange, className, disabled, defaultChecked },
  ref) =>
  {
    const [hovering, setHovering] = useState(false);
    const [isChecked, setIsChecked] = useState(defaultChecked || false);

    let styles;

    switch (true) {
      case isChecked && disabled:
        styles = 'bg-success-300 border-success-300 text-white hover:cursor-not-allowed';
        break;

      case !isChecked && disabled:
        styles = 'text-primary-300 border-primary-300 hover:cursor-not-allowed';
        break;

      case isChecked && !disabled:
        styles =
        'bg-success-700 border-success-700 text-white hover:cursor-pointer hover:bg-error-700 hover:border-error-700';
        break;

      default:
        styles =
        'text-primary-700 border-primary-700 bg-white hover:cursor-pointer hover:bg-success-700 hover:border-success-700 hover:text-white';
        break;
    }

    return /*#__PURE__*/(
      _jsx("label", {
        "data-testid": "enable-button-checkbox",
        className: `inline-flex relative text-sm font-medium ${className}`,
        onMouseEnter: () => {
          setHovering(true);
        },
        onMouseLeave: () => {
          setHovering(false);
        } }, void 0, /*#__PURE__*/

      React.createElement("input", {
        type: "checkbox",
        disabled: disabled,
        defaultChecked: defaultChecked,
        name: name,
        onChange: (event) => {
          setIsChecked(event.target.checked);

          if (onChange) {
            onChange(event);
          }
        },
        className: "sr-only",
        ref: ref }
      ), /*#__PURE__*/

      _jsx("div", {
        className: `px-1 py-2 w-24 text-sm font-medium text-center truncate rounded-lg border ${styles}` }, void 0, /*#__PURE__*/

      _jsx(Text, { checked: isChecked, hovering: hovering, disabled: disabled })
      )
      ));

  }
);

export { EnableButtonCheckbox };